import React, { useState } from 'react';
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import VideoInfoModule from 'components/templates/videoInfoModule';
import './styles.scss';

const MachineCraft = props => {
  const { data } = props.data;
  const { breadcrumbList } = props;

  const [showDescriptionLayout, setShowDescriptionLayout] = useState(false);
  const {
    machineCraftSection,
    machineCraftOverlay,
    testingForWorkspaces,
    type = 'homes',
    noPadding = false,
  } = data;

  function extractVideo() {
    return { __html: machineCraftSection.video };
  }

  const checkButton = () => {
    if (type === 'workcations' && testingForWorkspaces) {
      return 'EXPLORE';
    } else if (type === 'homes' && machineCraftOverlay) {
      return 'EXPLORE MACHINECRAFT';
    }

    return false;
  };

  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={
          type === 'workcations' ? testingForWorkspaces : machineCraftOverlay
        }
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'machineCraft'}
        className={'ourHomesOverlay'}
        onClosePress={() => setShowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
          {
            breadcrumbName: breadcrumbList[2].breadcrumbName,
            breadcrumbLink: breadcrumbList[2].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'machine-craft-section'}>
      <VideoInfoModule
        onClick={() => setShowDescriptionLayout(true)}
        heading={machineCraftSection.heading}
        subHeading={machineCraftSection.sub_heading}
        content={machineCraftSection.paragraph}
        buttonName={checkButton()}
        videoData={extractVideo()}
        videoThumbnailUrl={machineCraftSection.video_thumbnail_url}
        containerClassName={noPadding && 'machine-craft'}
      />
      {showOverlay}
    </div>
  );
};

export default MachineCraft;
